import axios, { AxiosRequestConfig } from "axios";
import qs from "qs";
import { UserModule } from "@/store/modules/user";
import { AppModule } from "@/store/modules/app";
// import { Toast } from "vant";
import { Message } from "element-ui";
import router from "@/router";
import { toLogin, getPlatform } from "./auth";
import { isJiHE } from "@/utils";
import Vue from "vue";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    "content-type": "application/x-www-form-urlencoded"
  }
});

interface IDefaultParams {
  platform: string;
  /** 时间戳，防止部分环境接口缓存 */
  _t: number;
  token?: string;
}

// Request interceptors
instance.interceptors.request.use(
  config => {
    const defaultParams: IDefaultParams = {
      platform: getPlatform(),
      _t: +new Date()
    };

    if (isJiHE()) {
      if (window.navigator.userAgent.search(/IOS/i) >= 0) {
        defaultParams.platform = "ios";
      } else {
        defaultParams.platform = "android";
      }
    }

    defaultParams.token = UserModule.token;
    if (config.method === "get") {
      if (!config.params) {
        config.params = defaultParams;
      } else {
        config.params = Object.assign({}, defaultParams, config.params);
      }
    } else if (config.method === "post") {
      if (!config.data) {
        config.data = defaultParams;
      } else {
        config.data = Object.assign({}, defaultParams, config.data);
      }
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    // Handle request error here
    Promise.reject(error);
  }
);

// Response interceptors
instance.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错
     */
    const res = response.data;
    console.log("instance.interceptors.response.use", response);

    if (Number(res.code) !== 200) {
      // 301:用户未登录;
      // 免登路由不显示抛错，也不跳登录页面
      if (Number(res.code) === 301) {
        UserModule.Logout();
        if (!AppModule.whiteList.includes(window.location.pathname)) {
          Message(res.message);
          toLogin();
        }
      } else {
        // 您已经有此证书了", 3081)
        // "课程未学完", 3082)
        if (Number(res.code) !== 3081) {
          if (res.message) {
            setTimeout(() => {
              Message(res.message);
            }, 0);
          }
        } else if (Number(res.code) === 305) {
          Message("课程已下架，正在跳转至首页");
          setTimeout(() => {
            router.push("/");
          }, 2000);
        }
      }

      return Promise.reject(res.message);
    } else {
      // setTimeout(() => {
      //   if (window.$getCookie("zh_choose")) {
      //     window.$zh_tran(window.$getCookie("zh_choose"));
      //   } else {
      //     window.$zh_tran("t");
      //   }
      // }, 100);
      return Promise.resolve(response.data.data);
    }
  },
  error => {
    if (error.message && error.message != "Network Error") {
      Message(error.message);
    }
    return Promise.reject(error);
  }
);

export default function request(config: AxiosRequestConfig): any {
  return instance(config);
}
